module.exports = __webpack_public_path__ + "static/media/20150430_033549_589817.9a68ce3f.mp3";